import { render } from "./PickersPage.vue?vue&type=template&id=057dc613&ts=true"
import script from "./PickersPage.ts?vue&type=script&lang=ts"
export * from "./PickersPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__